export class UtilisateurCourantModel {
  id: number;
  idClient: number;
  guid: string;
}
